/* unplugin-vue-components disabled */import { render } from "./Basemap.vue?vue&type=template&id=f851e804&ts=true"
import script from "./Basemap.vue?vue&type=script&lang=ts"
export * from "./Basemap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__